module.exports = __webpack_public_path__ + "static/media/consumer-power-desktop.3b1ed554.jpg";